import * as areas from "./areas";
import * as moveDates from "./moveDates";
import * as people from "./people";
import * as transaction from "./transaction";
import * as units from "./units";
import * as addPersonTransaction from "./addPersonTransaction";
import * as deletePersonTransaction from "./deletePersonTransaction";
import * as bulkPeopleTransactions from "./bulkPeopleTransactions";
import * as reviewers from "./reviewers";
// import * as planReview from "./planReview";

/*
  transactions

    assignPeopleToArea
    assignPeopleToUnit
    unassignPeople

    assignUnitsToArea
    unassignUnits

    addArea
    deleteArea
    renameArea
    unassignArea

    setPeopleMoveDates

*/

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

export function addArea(areaType,areaId,areaName) {
  const task = {
    preparor: areas,
    areaType: areaType,
    areaId: areaId,
    areaName: areaName,
    addArea: true
  };
  return execute(task);
}

export function assignPeopleToArea(peopleFeatureItems,areaItem,areaType,duplicatePeople) {
  const task = {
    preparor: people,
    peopleFeatureItems: peopleFeatureItems,
    duplicatePeople: duplicatePeople,
    assignPeopleToArea: {
      areaItem: areaItem,
      areaType: areaType
    }
  };
  return execute(task);
}

export function assignPeopleToUnit(peopleFeatureItems,unitFeatureItem,unassignCurrentOccupants,duplicatePeople) {
  const task = {
    preparor: people,
    peopleFeatureItems: peopleFeatureItems,
    duplicatePeople: duplicatePeople,
    assignPeopleToUnit: {
      unitFeatureItem: unitFeatureItem,
      unassignCurrentOccupants: unassignCurrentOccupants
    }
  };
  return execute(task);
}

export function assignUnitsToArea(unitFeatureItems,areaItem,areaType,peopleData) {
  const task = {
    preparor: units,
    unitFeatureItems: unitFeatureItems,
    peopleData: peopleData,
    assignUnitsToArea: {
      areaItem: areaItem,
      areaType: areaType
    }
  };
  return execute(task);
}

export function deleteArea(areaItem,areaType) {
  const task = {
    preparor: areas,
    areaItem: areaItem,
    areaType: areaType,
    unassignArea: true,
    deleteArea: true
  };
  return execute(task);
}

export function renameArea(areaItem,areaType,areaName) {
  const task = {
    preparor: areas,
    areaItem: areaItem,
    areaType: areaType,
    areaName: areaName,
    renameArea: true
  };
  return execute(task);
}

export function setPeopleMoveDates(changes,globalIds,moveDate) {
  const task = {
    preparor: moveDates,
    changes: changes,
    globalIds: globalIds,
    moveDate: moveDate,
    setPeopleMoveDates: true
  };
  return execute(task);
}

export function unassignArea(areaItem,areaType,peopleData) {
  const task = {
    preparor: areas,
    areaItem: areaItem,
    areaType: areaType,
    unassignArea: true,
    peopleData: peopleData
  };
  return execute(task);
}

export function unassignPeople(peopleFeatureItems, duplicatePeople) {
  const task = {
    preparor: people,
    peopleFeatureItems: peopleFeatureItems,
    unassignPeople: true,
    duplicatePeople: duplicatePeople
  };
  return execute(task);
}

export function unassignUnits(unitFeatureItems, peopleData) {
  const task = {
    preparor: units,
    unitFeatureItems: unitFeatureItems,
    unassignUnits: true,
    peopleData: peopleData
  };
  return execute(task);
}

export function addPerson(basePersonFeature, unitFeature, areaFeature, unassignOthers, duplicatePeople) {
  const task = {
    preparor: addPersonTransaction,
    basePersonFeature: basePersonFeature,
    unitFeature: unitFeature,
    areaFeature: areaFeature,
    unassignOthers: unassignOthers,
    duplicatePeople: duplicatePeople
  };
  return execute(task);
}

export function deletePeople(peopleFeatures, isRemoveAll) {
  const task = {
    preparor: deletePersonTransaction,
    peopleFeatures: peopleFeatures,
    isRemoveAll: isRemoveAll
  }
  return execute(task);
}

// Delete all duplicates and leave one record unassigned
export function bulkPanelUnassignPeople(people) {
  const task = {
    preparor: bulkPeopleTransactions,
    people: people,
    bulkUnassignPeople: true
  }
  return execute(task);
}

// Assign and remove duplicates
export function bulkPanelAssignPeopleToUnit(people, unit) {
  const task = {
    preparor: bulkPeopleTransactions,
    people: people,
    unit: unit,
    bulkAssignPeopleToUnit: true
  }
  return execute(task);
}

// Duplicates
export function bulkPanelDuplicatePeopleToUnit(people, unit) {
  const task = {
    preparor: bulkPeopleTransactions,
    people: people,
    unit: unit,
    bulkDuplicatePeopleToUnit: true
  }
  return execute(task);
}

// Assign and remove duplicates
export function bulkPanelAssignPeopleToArea(people, area) {
  const task = {
    preparor: bulkPeopleTransactions,
    people: people,
    area: area,
    bulkAssignPeopleToArea: true
  }
  return execute(task);
}

// Duplicates
export function bulkPanelDuplicatePeopleToArea(people, area) {
  const task = {
    preparor: bulkPeopleTransactions,
    people: people,
    area: area,
    bulkDuplicatePeopleToArea: true
  }
  return execute(task);
}
  
export function selectPortalGroupReviewers(portalMembers/*, portalGroupId*/) {
  const task = {
    preparor: reviewers,
    portalMembers: portalMembers,
    // portalGroupId: portalGroupId
  }
  return execute(task)
}

export function addReviewer(username, /*portalGroupId, */planId/*, initTable*/) {
  const task = {
    preparor: reviewers,
    username: username,
    // portalGroupId: portalGroupId,
    planId: planId,
    // initTable: initTable
  }
  return execute(task)
}

export function removeReviewer(username/*, portalGroupId*/) {
  const task = {
    preparor: reviewers,
    username: username,
    // portalGroupId: portalGroupId,
    removeReviewer: true
  }
  return execute(task)
}

// export function updatePortalGroup(portalGroupId) {
//   const task = {
//     preparor: planReview,
//     portalGroupId: portalGroupId
//   }
//   return execute(task)
// }

// export function changeReadyStatus(status) {
//   const task = {
//     preparor: planReview,
//     status: status
//   }
//   return execute(task)
// }

export function removeAllReviewers(users) {
  const task = {
    preparor: reviewers,
    removeAll: true,
    usersToRemove: users
  }
  return execute(task)
}

export function updateReviewerStatus(username, /*portalGroupId, */status) {
  const task = {
    preparor: reviewers,
    username: username,
    // portalGroupId: portalGroupId,
    status: status
  }
  return execute(task)
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

function execute(task) {
  return task.preparor.prepare(task).then(transactionInfo => {
    task.transactionInfo = transactionInfo;
    const edits = transactionInfo.edits;
    if (edits && edits.length > 0) {
      return transaction.applyEdits(task,transactionInfo);
    }
  });
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
